import React, { useEffect, useState } from 'react';
import { Fade, useMediaQuery, useTheme } from '@material-ui/core';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import { useBillingType } from 'globals/hooks/useBillingType';
import { UserBillingType, UserRole } from 'globals/types';
import { useRole } from 'globals/hooks/useRole';
import SidePanel from './SidePanel';
import TopBar from './TopBar';
import { ContentBox, WrapperBox } from './FsUserPanelLayout.style-elements';
import TopBarNotification from './TopBarNotification';

const sidePanelId = 'fs-side-panel';

const FsUserPanelLayout: React.FC = ({ children }) => {
  const { isBlocked, isPaymentMethodIssue, isUpgraded } = useAppContext();
  const [isSidePanelActive, setIsSidePanelActive] = useState<boolean>(false);
  const isUserBillingTypeExcluded = useBillingType(UserBillingType.EXCLUDED);
  const isAdminOrAccountant = useRole([UserRole.ADMIN, UserRole.ACCOUNTANT]);
  const theme = useTheme();
  const isUpMd = useMediaQuery(theme.breakpoints.up('md'), {
    noSsr: true, // without this, useMediaQuery is causing additional update
  });
  const showTopBarNotification =
    isPaymentMethodIssue &&
    isUpgraded &&
    isAdminOrAccountant &&
    !isUserBillingTypeExcluded;

  const toggleSidePanel = (): void => {
    setIsSidePanelActive((prevState) => !prevState);
  };

  const closeSidePanel = (): void => {
    setIsSidePanelActive(false);
  };

  useEffect(() => {
    if (isUpMd) setIsSidePanelActive(false);
  }, [isUpMd]);

  return (
    <Fade in timeout={1000}>
      <WrapperBox
        isBlocked={isBlocked}
        withTopBarNotification={showTopBarNotification}
      >
        {!isBlocked && (
          <SidePanel
            active={isSidePanelActive}
            id={sidePanelId}
            onClose={closeSidePanel}
          />
        )}
        {showTopBarNotification && (
          <TopBarNotification>
            {defaultLocales.topBarSection.description}
          </TopBarNotification>
        )}
        <ContentBox>
          <TopBar onSidePanelTriggerChange={toggleSidePanel} />
          {children}
        </ContentBox>
      </WrapperBox>
    </Fade>
  );
};

export default FsUserPanelLayout;
